import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { upload } from "../../store/actions/vendor/Vendor";
import { Table, Button } from "reactstrap";
import { connect } from "react-redux";
import {
    addDiscount,
    getColumns,
    getDiscountDetail,
    updateDiscount
} from "../../store/actions/admin/Admin";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import CardFooter from "../../components/Card/CardFooter.js";
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import CustomInput from "../../components/CustomInput/CustomInput.js";

const styles = {
    typo: {
        paddingLeft: "25%",
        marginBottom: "40px",
        position: "relative",
    },
    note: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        bottom: "10px",
        color: "#c0c1c2",
        display: "block",
        fontWeight: "400",
        fontSize: "13px",
        lineHeight: "13px",
        left: "0",
        marginLeft: "20px",
        position: "absolute",
        width: "260px",
    },
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0",
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
    },
};

const useStyles = makeStyles(styles);

const TABLE_LIST = [
    'SuperCategory', 'Category', 'SubCategory', 'Vendors', 'Products'
]

const AddDiscount = (props) => {
    const classes = useStyles();
    const [discount, updateDiscount] = useState({
    });
    const [columnNames, setColumnNames] = useState([]);
    useEffect(() => {
        var discountId = props.match.params.id;
        if (discountId)
            props.getDiscountDetail(discountId).then((obj) => {
                const data = obj.data
                props.getColumns(data.tableName)
                updateDiscount({
                    id: data.id,
                    value: data.value,
                    discountType: data.discountType,
                    tableColumn: data.tableColumn,
                    tableName: data.tableName,
                    condition: data.condition,
                    name: data.name,
                    couponCode: data.couponCode,
                    couponCount: data.couponCount
                })
            });
    }, []);



    useEffect(() => {
        if (props.columnNames && props.columnNames.length > 0)
            setColumnNames(props.columnNames);
    }, props.columnNames);


    const onChange = (event) => {
        let tempDiscount = { ...discount };
        tempDiscount[event.target.name] = event.target.value;
        updateDiscount(tempDiscount);
        if (event.target.name === 'tableName') {
            props.getColumns(event.target.value)
        }
    };


    const onSubmit = (event) => {
        event.preventDefault();
        if (props.match.params.id) {
            props.updateDiscount(discount).then((data) => {
                if (data) {
                    props.history.push(
                        `/admin/discounts`
                    );
                }
            }).catch((e)=>{

            });
        } else {
            props.addDiscount(discount).then((data) => {
                if (data) {
                    props.history.push(
                        `/admin/discounts`
                    );
                }
            }).catch((e)=>{
                
            });
        }
    };
    return (
        <>
            <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>Add Discount</h4>
            </CardHeader>
            <CardBody>
                <br />
                <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                        <CustomInput
                            labelText="Discount Name"
                            value={discount?.name}
                            onChange={onChange}
                            name="name"
                            id="name"
                            formControlProps={{
                                fullWidth: true,
                            }}
                        />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                        <select
                            fullWidth={true}
                            required="required"
                            name="discountType"
                            id="inputState"
                            className="form-control"
                            value={discount?.discountType}
                            onChange={onChange}
                            style={{ marginTop: "2.5em" }}
                        >
                            <option disabled="disabled" selected="selected">
                                Discount Type
                                </option>
                            <option value={'FIXED'} key={'FIXED'}>
                                {'Fixed'}
                            </option><option value={'PERCENTAGE'} key={'PERCENTAGE'}>
                                {'Percentage'}
                            </option>
                        </select>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={4}>
                        <select
                            fullWidth={true}
                            required="required"
                            name="tableName"
                            id="inputState"
                            className="form-control"
                            value={discount?.tableName}
                            onChange={onChange}
                            style={{ marginTop: "2.5em" }}
                        >
                            <option disabled="disabled" selected="selected">
                                Discount Table
                                </option>
                            {
                                TABLE_LIST
                                    .map((table_name) => (
                                        <option value={table_name} key={table_name}>
                                            {table_name}
                                        </option>
                                    ))
                            }
                        </select>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                        <select
                            fullWidth={true}
                            required="required"
                            name="tableColumn"
                            id="inputState"
                            className="form-control"
                            value={discount?.tableColumn}
                            onChange={onChange}
                            style={{ marginTop: "2.5em" }}
                        >
                            <option disabled="disabled" selected="selected">
                                Table Column
                                </option>
                            {
                                columnNames
                                    .map((column) => (
                                        <option value={column} key={column}>
                                            {column}
                                        </option>
                                    ))
                            }
                        </select>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                        <CustomInput
                            labelText="Discount Condition"
                            value={discount?.condition}
                            onChange={onChange}
                            name="condition"
                            id="condition"
                            formControlProps={{
                                fullWidth: true,
                            }}
                        />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                        <CustomInput
                            labelText="Discount Value"
                            value={discount?.value}
                            type="number"
                            onChange={onChange}
                            name="value"
                            id="value"
                            formControlProps={{
                                fullWidth: true,
                            }}
                        />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                        <CustomInput
                            labelText="Coupon Count"
                            value={discount?.couponCount}
                            type="number"
                            onChange={onChange}
                            name="couponCount"
                            id="couponCount"
                            formControlProps={{
                                fullWidth: true,
                            }}
                        />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                        <CustomInput
                            labelText="Coupon Code"
                            readonly={discount?.id ? true : false}
                            value={discount?.couponCode}
                            onChange={onChange}
                            name="couponCode"
                            id="couponCode"
                            formControlProps={{
                                fullWidth: true,
                            }}
                        />
                    </GridItem>
                    <br />
                </GridContainer>
            </CardBody>
            <CardFooter>
                <Button
                    type="submit"
                    onClick={onSubmit}
                    style={{
                        color: "#fff",
                        backgroundColor: "#9c27b0",
                        boxShadow:
                            "0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)",
                    }}
                >
                    {props.match.params.id ? 'Update Discount' : 'Add Discount'}
                </Button>
            </CardFooter>
            <br /> <br />
        </>
    );
};

const mapStateWithProps = (state) => ({
    discount: state.admin.discount,
    columnNames: state.admin.columnNames
});
const mapDispatchWithProps = (dispatch) => {
    return {
        getDiscountDetail: (discountId) => dispatch(getDiscountDetail(discountId)),
        getColumns: (tableName) => dispatch(getColumns(tableName)),
        updateDiscount: (discount) => dispatch(updateDiscount(discount)),
        addDiscount: (discount) => dispatch(addDiscount(discount)),
    };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(AddDiscount);
